import { onProductTemplateActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { ProductTemplateActivityCard } from "./ProductTemplateActivityCard";
import { useCurrentUser } from "common/SessionContext";

interface Props {
  productTemplateId: number
  config: server.dto.ActivityPanelConfig
}

export const ProductTemplateActivityPanel = (props: Props) => {
  const currentUser = useCurrentUser();
  return <ActivityPanel<server.dto.ProductTemplateActivity>
    activityKey="productTemplate"
    itemId={props.productTemplateId}
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.ProductTemplates.ListActivity({ itemId: props.productTemplateId, page, perPage })}
    renderActivity={(activity => <ProductTemplateActivityCard key={activity.activityId} activity={activity} />)}
    onActivityRegisterFn={onProductTemplateActivity}
    onActivity={(activity) => {
      const iAmActor = (activity.actor?.userId === currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}
